import { createSlice } from '@reduxjs/toolkit';

import type { AsyncStatus } from '@/shared/types/asyncState';

import type { PorteiroDetalheResposta } from '../../types/porteiroObservabilidade';

import { fetchDetalheDaAvaliacaoDoPorteiro, revisarEscapeDoPorteiro } from './actions';

interface PorteiroAvaliacaoState {
  detalhe: PorteiroDetalheResposta | null;
  status: AsyncStatus;
  error: string | null;
  /**
   * Abrir outra avaliação antes da anterior voltar: sem a guarda, a trilha atrasada de A apareceria
   * no drawer de B.
   */
  requestIdAtual: string | null;
  revisaoStatus: AsyncStatus;
  revisaoErro: string | null;
}

const initialState: PorteiroAvaliacaoState = {
  detalhe: null,
  status: 'idle',
  error: null,
  requestIdAtual: null,
  revisaoStatus: 'idle',
  revisaoErro: null,
};

const porteiroAvaliacaoSlice = createSlice({
  name: 'porteiroAvaliacao',
  initialState,
  reducers: {
    fecharAvaliacaoDoPorteiro: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDetalheDaAvaliacaoDoPorteiro.pending, (state, action) => {
        // A trilha de outra avaliação não pode ficar na tela enquanto a nova carrega.
        state.detalhe = null;
        state.status = 'loading';
        state.error = null;
        state.revisaoStatus = 'idle';
        state.revisaoErro = null;
        state.requestIdAtual = action.meta.requestId;
      })
      .addCase(fetchDetalheDaAvaliacaoDoPorteiro.fulfilled, (state, action) => {
        if (state.requestIdAtual !== action.meta.requestId) return;
        state.status = 'success';
        state.detalhe = action.payload;
      })
      .addCase(fetchDetalheDaAvaliacaoDoPorteiro.rejected, (state, action) => {
        if (action.meta.aborted || state.requestIdAtual !== action.meta.requestId) return;
        state.status = 'error';
        state.error = action.payload ?? 'Erro desconhecido';
      })
      .addCase(revisarEscapeDoPorteiro.pending, (state) => {
        state.revisaoStatus = 'loading';
        state.revisaoErro = null;
      })
      .addCase(revisarEscapeDoPorteiro.fulfilled, (state, action) => {
        state.revisaoStatus = 'success';
        // Só troca a trilha se o drawer ainda mostra a avaliação revisada.
        if (state.detalhe?.avaliacao.id === action.meta.arg.avaliacaoId) {
          state.detalhe = action.payload;
        }
      })
      .addCase(revisarEscapeDoPorteiro.rejected, (state, action) => {
        state.revisaoStatus = 'error';
        state.revisaoErro = action.payload ?? 'Erro desconhecido';
      });
  },
});

export const { fecharAvaliacaoDoPorteiro } = porteiroAvaliacaoSlice.actions;
export const porteiroAvaliacaoReducer = porteiroAvaliacaoSlice.reducer;
